export default __webpack_public_path__ + "static/media/item.534e21ae.png";